import React from "react";
import AppContext from "../../../../contexts/AppContext";
import { UserContext } from "../../../../contexts/UserContext";
import { saveCoordinates, saveLocation } from "../../../../utils/helperFunctions";
import { fetchAddressFromCoordinates } from "../../../../utils/LocationLib";
import ShareLocationPopup from "../../../common/dialogs/ShareLocationPopup";
import BOTagBodyDeliveryLocation from "../BOTagComponents/BOTagBodyDeliveryLocation";
import BOTagBodyDeliveryUnavailable from "../BOTagComponents/BOTagBodyDeliveryUnavailable";
import BOTagBodyReadyToBuy from "../BOTagComponents/BOTagBodyReadyToBuy";
import BOTagBodyStoreAway from "../BOTagComponents/BOTagBodyStoreAway";

export const BOTagBodyDefault = ({
    pickupInfo,
    courierInfo,
    shippingInfo,
    deliveryMethod,
    fastestOption,
    botagData,
    GTINbarcode,
    selectedQuantity,
    selectedColor,
    selectedSize,
    deliveryPreference,
    gtinNotFound,
    productOutOfStock,
    storeTooAway,
    setStoreTooAway,
    pickupDistance,
    animate,
    setAnimate,
    fireworks,
    setFireworks,
    headerMessage,
    setHeaderMessage,
    overQuantity,
    overQuantityNumber,
    checkAnotherLoactionBtn,
    setCheckAnotherLoactionBtn
}) => {
    /* #region VARS */
    const { setSelectedBotag, selectedBotag } = React.useContext(AppContext);
    const { setUserGPSCoordinates, setUserAddress } = React.useContext(UserContext);

    const [showLocationPopup, setShowLocationPopup] = React.useState(false);
    const [selectedBotagBeforeLocationPopup, setSelectedBotagBeforeLocationPopup] = React.useState(null);
    let showUnavailable = false;
    let unavailableReason = "";
    let unavailableReasonError = "";
    let textColor = "";
    let deliveryData;

    const isPickupAvailableOnAlgorithmn = pickupInfo?.available;
    const isCourierAvailableOnAlgorithmn = courierInfo?.available;
    const isShippingAvailableOnAlgorithmn = shippingInfo?.available;
    const GTINHasStock = botagData?.stockData?.find(data => data.GTINbarcode === GTINbarcode)?.totalStock > 0;
    const allGTINSDontHaveStock = botagData?.stockData?.every(data => data.totalStock <= 0);

    if (!selectedBotag?.stockData.length) {
        showUnavailable = true;
        unavailableReason = "This product is out of stock in all colors and sizes in all stores.";
        setHeaderMessage(true);
    } else if (gtinNotFound) {
        showUnavailable = true;
        unavailableReason = "The selected color and size combination is out of stock in all stores.";
        unavailableReasonError = "You can still check different sizes and colors by selecting above.";
        textColor = "#F7665F";
        setHeaderMessage(true);
    } else if (
        overQuantity ||
        (!isPickupAvailableOnAlgorithmn && !isCourierAvailableOnAlgorithmn && !isShippingAvailableOnAlgorithmn && selectedQuantity > 1)
    ) {
        showUnavailable = true;
        unavailableReason = "The quantity selected is too high for a store to supply.";
        /*unavailableReasonError = `Max that a single store can supply is ${
            overQuantityNumber > 1 ? `${overQuantityNumber} items.` : `${overQuantityNumber} item.`
        }`;*/
        unavailableReasonError = "Please try reducing the quantity until you get a result.";
        //textColor = "#8C8C8C";
        textColor = "#F7665F";
        setHeaderMessage(true);
    } else if (productOutOfStock) {
        if (selectedQuantity === 1) {
            setHeaderMessage(true);
        } else {
            setHeaderMessage(false);
        }
        showUnavailable = true;
        unavailableReason = "This product is out of stock in all colors and sizes in all stores.";
    } else if (deliveryMethod === "pickup") {
        deliveryData = pickupInfo?.data;
        if (!isPickupAvailableOnAlgorithmn || !GTINHasStock || allGTINSDontHaveStock) {
            //setCheckAnotherLoactionBtn(true);
            setHeaderMessage(true);
            showUnavailable = true;
            //unavailableReason = "Oops! No store available for pick up for the selected color and size combination.";
            unavailableReason = "This product is out of stock in all colors and sizes in all stores.";
        } else {
            setHeaderMessage(false);
            //setCheckAnotherLoactionBtn(false);
        }
    } else if (deliveryMethod === "courier") {
        deliveryData = courierInfo?.data;
        if (allGTINSDontHaveStock) {
            setCheckAnotherLoactionBtn(false);
            showUnavailable = true;
            unavailableReason = "Oops! This product does not exist in any store that provide courier service.";
        } else if (!GTINHasStock) {
            setCheckAnotherLoactionBtn(false);
            showUnavailable = true;
            unavailableReason = "Oops! This color and size combination does not exist in any store that provide courier service.";
        } else if (!isCourierAvailableOnAlgorithmn) {
            showUnavailable = true;
            setCheckAnotherLoactionBtn(true);
            unavailableReason =
                "Oops! This color and size combination does not exist in any store that provide courier service to your shared location.";
        }
    } else if (deliveryMethod === "shipping") {
        deliveryData = shippingInfo?.data;

        if (allGTINSDontHaveStock) {
            setCheckAnotherLoactionBtn(false);
            showUnavailable = true;
            unavailableReason = "Oops! This product does not exist in any store that provide shipping service.";
        } else if (!GTINHasStock) {
            setCheckAnotherLoactionBtn(false);
            showUnavailable = true;
            unavailableReason = "Oops! This color and size combination does not exist in any store that provide shipping service.";
        } else if (!isShippingAvailableOnAlgorithmn) {
            setCheckAnotherLoactionBtn(true);
            showUnavailable = true;
            unavailableReason =
                "Oops! This color and size combination does not exist in any store that provide shipping service to your shared location.";
        }
    }
    const isIpLocation = localStorage.getItem("isIpLocation") === "true";
    /* #endregion */

    /* #region METHODS */
    const openBotag = () => {
        if (selectedBotagBeforeLocationPopup) {
            setSelectedBotag(selectedBotagBeforeLocationPopup);
            setSelectedBotagBeforeLocationPopup(null);
        }
    };
    const onLocationChanged = (location, isBotagOpen) => {
        const { latitude, longitude, city, country, postalCode } = location;

        setUserGPSCoordinates({ latitude, longitude });
        saveCoordinates({ latitude, longitude });

        fetchAddressFromCoordinates(latitude, longitude, city, country, postalCode).then(newUserAddress => {
            setUserAddress(newUserAddress);
            saveLocation(newUserAddress);

            if (selectedBotagBeforeLocationPopup && isBotagOpen) {
                localStorage.setItem("isBotagOpen", true);
                setSelectedBotag(selectedBotagBeforeLocationPopup);
                setSelectedBotagBeforeLocationPopup(null);
            }
        });
    };
    /* #endregion */

    return (
        <div className="frame-313501">
            <ShareLocationPopup
                visible={showLocationPopup}
                setVisible={setShowLocationPopup}
                onLocationSelected={onLocationChanged}
                openBotag={openBotag}
            />
            {(deliveryMethod === "courier" || deliveryMethod === "shipping") && isIpLocation ? (
                <div className="w-100">
                    <BOTagBodyDeliveryLocation deliveryMethod={deliveryMethod} setShowLocationPopup={setShowLocationPopup} />
                </div>
            ) : showUnavailable ? (
                <BOTagBodyDeliveryUnavailable
                    unavailableReason={unavailableReason}
                    unavailableReasonError={unavailableReasonError}
                    headerMessage={headerMessage}
                    textColor={textColor}
                    checkAnotherLoactionBtn={checkAnotherLoactionBtn}
                    setShowLocationPopup={setShowLocationPopup}
                    deliveryMethod={deliveryMethod}
                />
            ) : storeTooAway && deliveryMethod === "pickup" && localStorage.getItem("dontShow") !== "true" ? (
                <BOTagBodyStoreAway
                    pickupDistance={pickupDistance}
                    setStoreTooAway={setStoreTooAway}
                    deliveryMethod={deliveryMethod}
                    fastestOption={fastestOption}
                    deliveryPreference={deliveryPreference}
                />
            ) : (
                <BOTagBodyReadyToBuy
                    deliveryData={deliveryData}
                    deliveryMethod={deliveryMethod}
                    GTINbarcode={GTINbarcode}
                    selectedQuantity={selectedQuantity}
                    selectedColor={selectedColor}
                    selectedSize={selectedSize}
                    deliveryPreference={deliveryPreference}
                    animate={animate}
                    setAnimate={setAnimate}
                    fireworks={fireworks}
                    setFireworks={setFireworks}
                />
            )}
        </div>
    );
};
